import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gizlilik',
  templateUrl: './gizlilik.component.html',
  styleUrls: ['./gizlilik.component.scss']
})
export class GizlilikComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
